import BlockIcon from '@mui/icons-material/Block';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { type ReactElement } from 'react';
import { useLocalizedStrings } from '../../localization/LocalizedStringsProvider';
import { fillHeight } from '../../theme';

// Shown when a user lands on a page they don't have read access to (see RequirePermission).
const Unauthorized = (): ReactElement => {
    const strings = useLocalizedStrings();

    return (
        <Box
            sx={{
                ...fillHeight,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                p: 4,
                gap: 2,
            }}
        >
            <BlockIcon color="error" sx={{ fontSize: 120 }} />
            <Typography variant="h5">{strings.unauthorizedTitle}</Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 480 }}>
                {strings.unauthorizedMessage}
            </Typography>
        </Box>
    );
};

export default Unauthorized;
